import { BrokerExtensions } from "@primaria/plugins-core";
import { UpdateHistoryItemHandler } from "./handler";
import { BrokerDisposableHandler } from "@uxland/primary-shell";

let request: BrokerDisposableHandler;

export const bootstrapUpdateHistoryItem = (broker: BrokerExtensions) => {
  request = broker.registerRequest("update_history_item_request", UpdateHistoryItemHandler);
};

export const teardownUpdateHistoryItem = () => {
  request?.dispose();
};
